import './eleve.scss';
import React, { useEffect, useState } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Card, Breadcrumb, Tabs } from 'antd';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { AUTHORITIES } from 'app/config/constants';
import { getEleveByAnneeScolaire } from './eleve.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import PersonalInfoTab from './PersonalInfo';
import PointagesAbsencesTab from './PointagesAbsencesTab';
import PaiementsTab from './PaiementsTab';
import DispensesTab from './DispensesTab';
import EleveControleAcces from 'app/entities/controle-acces/EleveControleAcces';
import { getSession } from 'app/shared/reducers/authentication';
import { UserOutlined, ScheduleOutlined, CreditCardOutlined, StopOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const { TabPane } = Tabs;

export const EleveDetail = (props: RouteComponentProps<{ id: string; ecoleid: string; anneeScolaireId: string }>) => {
  const dispatch = useAppDispatch();
  const id = props.match.params.id;
  const ecoleId = props.match.params.ecoleid;
  const anneeScolaireId = props.match.params.anneeScolaireId;
  const listSearch = props.location.search || '';
  const [activeTab, setActiveTab] = useState('1');
  const authorities = useAppSelector(state => state.authentication.account.authorities);
  const canViewAccessRights = authorities?.some(authority =>
    [AUTHORITIES.ADMIN, AUTHORITIES.DIRECTEUR, AUTHORITIES.DIRECTEUR_ETUDE, AUTHORITIES.SURVEILLANT_GENERAL].includes(authority)
  );

  useEffect(() => {
    dispatch(getSession());
    const entity = {
      id,
      anneeScolaireId,
    };
    dispatch(getEleveByAnneeScolaire(entity));

    dispatch(getEcole(ecoleId));
  }, [dispatch, id, ecoleId]);

  const handleTabChange = (key: string) => {
    setActiveTab(key);
  };

  return (
    <>
      <Breadcrumb className="py-4">
        <Breadcrumb.Item>
          <Link to={`/home/${ecoleId}/${anneeScolaireId}`}>École</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Link
            to={{
              pathname: `/eleve/${ecoleId}/${anneeScolaireId}`,
              search: listSearch,
            }}
          >
            Élèves
          </Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Détails</Breadcrumb.Item>
      </Breadcrumb>

      <Card>
        <Tabs defaultActiveKey="1" activeKey={activeTab} onChange={handleTabChange}>
          <TabPane
            tab={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <UserOutlined />
                Informations personnelles
              </span>
            }
            key="1"
          >
            <PersonalInfoTab anneeScolaireId={anneeScolaireId} props={props} isActive={activeTab === '1'} />
          </TabPane>
          <TabPane
            tab={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <ScheduleOutlined />
                Pointages & Abscences
              </span>
            }
            key="2"
          >
            <PointagesAbsencesTab eleveId={id} isActive={activeTab === '2'} anneeScolaireId={anneeScolaireId} props={props} />
          </TabPane>
          <TabPane
            tab={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <CreditCardOutlined />
                Paiements Scolarité
              </span>
            }
            key="3"
          >
            <PaiementsTab eleveId={id} isActive={activeTab === '3'} props={props} anneeScolaireId={anneeScolaireId} />
          </TabPane>
          <TabPane
            tab={
              <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <StopOutlined />
                Dispenses
              </span>
            }
            key="4"
          >
            <DispensesTab isActive={activeTab === '4'} />
          </TabPane>
          {canViewAccessRights && (
            <TabPane
              tab={
                <span style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  <SafetyCertificateOutlined />
                  Contrôle d’accès
                </span>
              }
              key="5"
            >
              <EleveControleAcces eleveId={id} anneeScolaireId={anneeScolaireId} isActive={activeTab === '5'} />
            </TabPane>
          )}
        </Tabs>
      </Card>
    </>
  );
};

export default EleveDetail;
